export default "__VITE_ASSET__CD6s3rE7__"